<script>

import feedbacks from '@core/components/content/app/feedbacks'

export default{

  extends: feedbacks,

  methods: {

    set_details_new: function (index) {
      var votes = this.get_votes()

      if (!votes || !votes.length) { return false }

      for (var i = 0; i < votes.length; i++) {
        if (votes[i].ID == index.ID) { this.details = votes[i] }
      }
    }
  },
  mounted () {
    var my_class = this

    this.$store.dispatch('get_user_boards')

 	 	this.$store.dispatch('get_all_votes', {callback: function () {
      if (typeof my_class.$route.params.id !== 'undefined' && typeof my_class.$route.params.board !== 'undefined') { my_class.set_details_new({'ID': my_class.$route.params.id, 'board': my_class.$route.params.board}) }
		 }})

    this.filter = this.$route.params.board
  }

}

</script>
